// extracted by mini-css-extract-plugin
export default {"ModalBody":"DealSuccessModal_ModalBody__9vYO3","SuccessImg":"DealSuccessModal_SuccessImg__CM0VN","Heading":"DealSuccessModal_Heading__5sLKU"};